import React, { useContext } from 'react';
import styled, { ThemeContext } from 'styled-components';
import { Icon, IconName } from '../icon';
import { Typography } from '../typography';

interface NoDataProps {
	message: string | React.ReactNode;
	color?: string;
	icon?: IconName;
	width?: string;
	height?: string;
}

const NoDataBase = styled.div<{ color: string }>`
	color: ${props => props.color};
	display: flex;
	flex-direction: column;
	align-items: center;
`;

export const NoData = (props: NoDataProps) => {
	const { color, message } = props;
	const theme = useContext(ThemeContext);
	return (
		<NoDataBase color={color}>
			<Icon
				iconName={props.icon ?? 'NoData'}
				sx={{ width: props.width ?? '24px', height: props.height ?? '24px', color: props.color ?? theme.colors.font }}
			/>
			{typeof message == 'string' ? <Typography style={{ margin: 0 }}>{message}</Typography> : message}
		</NoDataBase>
	);
};
